// 平台管理
import platformManagement from './url/platform-management.js'
// 用户信息
import userInfo from './url/user-info.js'
// 项目
import project from './url/project.js'
// 任务
import task from './url/task.js'
// 任务
import other from './url/other.js'

let urlList = Object.assign(
  {},platformManagement,userInfo,project,task,other
)
export default urlList